import { useState } from "react";
import { mockAlertConfigs } from "@/mocks/contracts";

export default function AlertsSettings() {
  const [configs, setConfigs] = useState(mockAlertConfigs);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-primary-600 text-xl md:text-2xl font-bold">Alert Settings</h1>
        <p className="text-foreground-500 text-sm mt-1">
          Configure expiry alert tiers, escalation rules, and notification recipients
        </p>
      </div>

      <div className="bg-white rounded-lg border border-background-200 overflow-hidden">
        <div className="p-5 border-b border-background-200">
          <h2 className="text-primary-600 text-base font-semibold">Alert Tiers</h2>
          <p className="text-foreground-500 text-sm mt-0.5">
            Configure how many days before expiry each tier fires and who gets notified
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                <th className="text-left text-xs font-semibold text-foreground-500 uppercase tracking-wider px-4 py-3 whitespace-nowrap">
                  Tier
                </th>
                <th className="text-left text-xs font-semibold text-foreground-500 uppercase tracking-wider px-4 py-3 whitespace-nowrap">
                  Days Before Expiry
                </th>
                <th className="text-left text-xs font-semibold text-foreground-500 uppercase tracking-wider px-4 py-3 whitespace-nowrap">
                  Escalation (Days)
                </th>
                <th className="text-left text-xs font-semibold text-foreground-500 uppercase tracking-wider px-4 py-3 whitespace-nowrap">
                  Notify Roles
                </th>
              </tr>
            </thead>
            <tbody>
              {configs
                .sort((a, b) => b.tierDays - a.tierDays)
                .map((config, i) => (
                  <tr key={config.id} className="border-b border-background-100">
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold ${
                        i === 0 ? "bg-background-100 text-foreground-600" :
                        i === 1 ? "bg-primary-50 text-primary-700" :
                        i === 2 ? "bg-accent-50 text-accent-700" :
                        "bg-foreground-100 text-foreground-700"
                      }`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${
                          i === 0 ? "bg-background-400" :
                          i === 1 ? "bg-primary-500" :
                          i === 2 ? "bg-accent-500" :
                          "bg-foreground-500"
                        }`}></span>
                        Tier {4 - i}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <input
                        type="number"
                        value={config.tierDays}
                        className="w-20 h-8 px-2 border border-background-300 rounded text-sm text-foreground-700 focus:outline-none focus:border-primary-500"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <input
                        type="number"
                        value={config.escalationDays}
                        className="w-20 h-8 px-2 border border-background-300 rounded text-sm text-foreground-700 focus:outline-none focus:border-primary-500"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap gap-1.5">
                        {config.notifyRoles.map((role) => (
                          <span
                            key={role}
                            className="inline-flex items-center px-2 py-0.5 rounded-full bg-foreground-100 text-foreground-600 text-xs font-medium"
                          >
                            {role}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="p-5 border-t border-background-200 flex items-center gap-3">
          <button className="h-10 px-5 bg-primary-600 text-white text-sm font-semibold rounded-md hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer">
            Save Configuration
          </button>
          <button className="h-10 px-5 border border-background-300 text-foreground-600 text-sm font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
            Reset to Defaults
          </button>
        </div>
      </div>
    </div>
  );
}